// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import { Redirect, Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { siteActions } from "../../../redux/actions/siteActions";
import isEmpty from "lodash.isempty";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import moment from 'moment';
import {
  Button
} from "react-bootstrap";

import "./dashboard.css";
var BarChart = require("react-d3-components").BarChart;

var BarData = [];
let salesAmt="";
class Dashboard extends Component {
   _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {},
      loading: false,
      startDate: moment().subtract(6, 'days'),
      endDate: moment(),
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
    };

    this.handleDateEvent = this.handleDateEvent.bind(this);
  }

  handleDateEvent(event, picker) {
    this.setState({
      startDate: picker.startDate,
      endDate: picker.endDate,
    });

    const {
      actions: { getDashobardData }
    } = this.props;

    let startDate = moment(picker.startDate).format("YYYY-MM-DD 00:00:00");
    let endDate = moment(picker.endDate).format("YYYY-MM-DD 23:59:59");
    getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:startDate,  endDate:endDate, site_id: localStorage.getItem("siteID")});
  }

  componentDidMount() {
    this._isMounted = true;
    const {
      actions: { getDashobardData }
    } = this.props;

    let startDate = moment(this.state.startDate).format("YYYY-MM-DD 00:00:00");
    let endDate = moment(this.state.endDate).format("YYYY-MM-DD 23:59:59");
    getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:startDate,  endDate:endDate, site_id: localStorage.getItem("siteID")});
    
    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboardData) {
      this.setState({ dashboardData: nextProps.dashboardData });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  tooltipBar(x, y, y0) {
    return (y==0) ? " Transactions : " + y0 :  " Sales : " + y0;
  };

  toDollars=( nValue, nWide )=> {
    var s= nValue.toFixed(2);
    let j;
    for( j=6; j<15; j+=4 ) {  // insert commas
        if ( s.length > j ) { 
            s= s.substr(0,s.length-j)+','+ s.substr(s.length-j);
        }
    }
    s= '$'+s;  // leading dollar sign
    if ( !isNaN(nWide) ) { // parameter is present
        while( nWide > s.length ) {  // pad with leading spaces
            s=' '+s;
        }
    }
    return(s);
  }

  render() {
    const { dashboardData } = this.state;
    if(dashboardData.graphRecord){
      BarData = dashboardData.graphRecord;
    }
    else
    {
      BarData = [];
    }

    let start = this.state.startDate.format('MMMM D, YYYY');
    let end = this.state.endDate.format('MMMM D, YYYY');
    let label = start + ' - ' + end;
    if (start === end) {
      label = start;
    }
    let buttonStyle = { width: '100%' };

    let contentOfferRow, contentCityRow;
    if (!isEmpty(dashboardData.topOffers)) {
      contentOfferRow = dashboardData.topOffers.map((val, index) => (
        <tr key={'topOffers'+index}>
          <td>{val.mainDealText}</td>
          <td>{val.merchantName}</td>
          <td>{val.amount}</td>
        </tr>
      ));
    }

    if (!isEmpty(dashboardData.topSellingCities)) {
      contentCityRow = dashboardData.topSellingCities.map((val, index) => (
        <tr key={'citySales'+index}>
          <td>{val.title}</td>
          <td>{val.amount}</td>
        </tr>
      ));
    }
    salesAmt = parseFloat(dashboardData.total_sale_amount);
    
    return (
      <AnimatedView>
        <div>
          <div className="row" style={{ marginBottom: "5px" }}>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + this.toDollars(salesAmt)}
                statLabel={"Total Sales"}
                icon={<i className="fa fa-dollar" />}
                backColor={"green"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.total_transactions) ? dashboardData.total_transactions : '0')}
                statLabel={"Total Transactions"}
                icon={<i className="fa fa-exchange" />}
                backColor={"violet"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.total_users) ? dashboardData.total_users : '0')}
                statLabel={"Total Users"}
                icon={<i className="fa fa-user" />}
                backColor={"red"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.voucher_sold) ? dashboardData.voucher_sold : '0')}
                statLabel={"Total Voucher Sold"}
                icon={<i className="fa fa-money" />}
                backColor={"blue"}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="panel">
                <div className="row">
                  <div className="col-md-8"><header className="panel-heading">Transactions</header></div>
                  <div className="col-md-4">
                  <DatetimeRangePicker
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    ranges={this.state.ranges}
                    onEvent={this.handleDateEvent}
                  >
                    <Button className="selected-date-range-btn" style={buttonStyle}>
                      <div className="pull-left">
                        <i className="fa fa-calendar"/>
                        &nbsp;
                        <span>
                          {label}
                        </span>
                      </div>
                      <div className="pull-right">
                        <i className="fa fa-angle-down"/>
                      </div>
                    </Button>
                  </DatetimeRangePicker>
                  </div>
                </div>
                <div className="panel-body">
                  {BarData.length > 0 ? (
                  <BarChart
                    groupedBars
                    data={BarData}
                    xAxis={{tickDirection : "diagonal"}}
                    tooltipHtml={this.tooltipBar}
                    width={900}
                    height={400}
                    style={{width: '100%'}}
                    margin={{ top: 10, bottom: 80, left: 50, right: 10 }}
                  />) : ("No Data Found ...")}
                </div>
              </div>
              {/*<WorkProgress />*/}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="panel">
                <header className="panel-heading">Top Selling Offers</header>
                <div className="panel-body">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Offer</th>
                        <th>Merchant</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>{contentOfferRow}</tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="panel">
                <header className="panel-heading">Top Selling Cities</header>
                <div className="panel-body">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>City</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>{contentCityRow}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimatedView>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.siteReducer.loading,
    error: state.siteReducer.error,
    dashboardData: state.siteReducer.dashboardData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/admin/dashboard/Dashboard.js